import { ChainId } from '@pancakeswap/sdk'
import Inventory from 'views/Inventory'
import { useRouter } from 'next/router'
import RegisterModal from 'components/Menu/Auth/RegisterModal'
import { Flex } from '@pancakeswap/uikit'
import styled from 'styled-components'

const ReferralSignUp = () => {
  const router = useRouter()
  return (
    <Container>
        <RegisterModal dataReferralCode={router?.query?.referral_code?.toString()}/>
    </Container>
    
  )
}

ReferralSignUp.chains = [ChainId.BSC, ChainId.BSC_TESTNET, ChainId.ONUS , ChainId.ONUS_TESTNET]

export default ReferralSignUp

const Container = styled(Flex)`
  align-items: center;
  justify-content: center;
`

